// Modules
import { produce } from 'immer'

// Constants
import { statusServerConstants } from 'components/Table/TableHistory/constants'

import {
  CREATE_WITHDRAWAL_SET_LOADING,
  GET_WITHDRAWAL_HISTORY,
  GET_WITHDRAWAL_METHODS,
  SET_CANCEL_WITHDRAWAL_SUCCESS,
  SET_IS_WITHDRAWAL_MODAL_INFO_OPEN,
  SET_LOADING_CANCEL_WITHDRAWAL,
  SET_WITHDRAWAL_HISTORY,
  SET_WITHDRAWAL_METHODS,
  SET_WITHDRAWAL_MODAL_ITEM_INFO,
} from 'store/actions/Withdrawal/types'

const initialState = {
  withdrawalHistoryList: null,
  loadingWithdrawalHistoryList: false,
  modalWithdrawalItemInfo: null,
  isWithdrawalModalInfoOpen: false,

  withdrawalMethods: null,
  withdrawalMethodsLoading: false,
  loadingCreateWithdrawal: false,
  loadingCancelWithdrawal: false,
}

const withdrawalReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_WITHDRAWAL_HISTORY:
      return produce(state, (draft) => {
        draft.withdrawalHistoryList = action.payload
        draft.loadingWithdrawalHistoryList = false
      })

    case GET_WITHDRAWAL_HISTORY:
      return produce(state, (draft) => {
        draft.withdrawalHistoryList = null
        draft.loadingWithdrawalHistoryList = true
      })

    case SET_IS_WITHDRAWAL_MODAL_INFO_OPEN:
      return produce(state, (draft) => {
        draft.isWithdrawalModalInfoOpen = action.payload
      })

    case SET_WITHDRAWAL_MODAL_ITEM_INFO:
      return produce(state, (draft) => {
        draft.modalWithdrawalItemInfo = action.payload
      })

    case SET_WITHDRAWAL_METHODS:
      return produce(state, (draft) => {
        draft.withdrawalMethods = action.payload
        draft.withdrawalMethodsLoading = false
      })

    case GET_WITHDRAWAL_METHODS:
      return produce(state, (draft) => {
        draft.withdrawalMethodsLoading = true
      })

    case CREATE_WITHDRAWAL_SET_LOADING:
      return produce(state, (draft) => {
        draft.loadingCreateWithdrawal = action.payload
      })

    case SET_LOADING_CANCEL_WITHDRAWAL:
      return produce(state, (draft) => {
        draft.loadingCancelWithdrawal = action.payload
      })

    case SET_CANCEL_WITHDRAWAL_SUCCESS:
      return produce(state, (draft) => {
        const data = draft.withdrawalHistoryList?.data
        if (!data) return

        const changed = data.map((item) =>
          item?.finance_id === action.payload?.financeId
            ? { ...item, status: { id: statusServerConstants?.failed } }
            : item,
        )

        draft.withdrawalHistoryList = { ...draft.withdrawalHistoryList, data: changed }
      })

    default:
      return state
  }
}
export default withdrawalReducer
